@use "src/sedestral/sass/mixins/texts";
@use "src/sedestral/sass/icons/icons";
@use "src/sedestral/sass/mixins/outline";

.componentAlert {
  padding: 12px;
  background-color: var(--orange);
  color: white;
  border-radius: 15px;
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 34px;
  font-size: 14px;

  &.big {
    background-color: var(--red) !important;

    .actions {
      .button {
        color: var(--red) !important;
      }
    }
  }

  &.blue {
    background: var(--white);
    color: var(--black);
    border: 1px solid var(--web-blue);

    .actions {
      .button {
        background: var(--black);
        color: var(--white) !important;
      }
    }
  }

  &.margin {
    margin-bottom: 15px;
  }

  .message {
    flex-grow: 1;

    b {
      @include texts.font("semi-bold");
    }

  }

  .icon {
    height: 32px;
    width: 32px;
    flex: 0 0 32px;
  }

  .iconComponent {
    height: 32px;
    width: 32px;
    flex: 0 0 32px;
  }

  .icon_3d-link {
    @include icons.ico("3d-link");
  }

  .icon_3d-website {
    @include icons.ico("3d-website");
  }

  .icon_3d-external-link {
    @include icons.ico("3d-external-link");
  }

  .actions {
    display: flex;
    gap: 10px;
    margin-left: 10px;

    .button {
      padding: 8px 20px;
      font-size: 15px;
      border: none;
      border-radius: 25px;
      background-color: white;
      color: var(--orange);
      cursor: pointer;
      text-wrap: nowrap;
    }
  }

  @media screen and (max-width: 480px) {
    flex-wrap: wrap;
    gap: 15px;
    justify-content: center;
  }
}